import { render, staticRenderFns } from "./ExemptReason.vue?vue&type=template&id=6f9c329a&"
import script from "./ExemptReason.vue?vue&type=script&lang=js&"
export * from "./ExemptReason.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports